(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => [...r.querySelectorAll(s)];
  const root = () => (window.Shopify?.routes?.root ? window.Shopify.routes.root : '/');
  const money = (cents) => {
    try {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    } catch (_) {}
    return `₹ ${(Number(cents) / 100).toLocaleString('en-IN')}`;
  };
  const WISH_KEY = 'viora_wishlist';
  const DEMO_CART_KEY = 'viora_demo_cart';
  const shopHref = () => `${root()}collections/all`;

  /* Sticky transparent header — always fixed */
  const header = qs('[data-header]');
  const headerSpacer = qs('[data-header-spacer]');
  const syncHeaderHeight = () => {
    if (!header) return;
    const h = Math.ceil(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--header-h', `${h}px`);
    if (headerSpacer && !headerSpacer.classList.contains('is-overlay')) {
      headerSpacer.style.height = `${h}px`;
    }
  };
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    onScroll();
    syncHeaderHeight();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', syncHeaderHeight, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(syncHeaderHeight).observe(header);
    }
  }

  /* Mobile nav */
  const mobileNav = qs('[data-mobile-nav]');
  qsa('[data-mobile-open]').forEach((btn) =>
    btn.addEventListener('click', () => mobileNav?.classList.add('is-open'))
  );
  qsa('[data-mobile-close]').forEach((btn) =>
    btn.addEventListener('click', () => mobileNav?.classList.remove('is-open'))
  );

  /* Cart drawer */
  const drawer = qs('[data-cart-drawer]');
  const openCart = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  };

  qsa('[data-cart-open]').forEach((el) =>
    el.addEventListener('click', (e) => {
      if (drawer) {
        e.preventDefault();
        refreshCartDrawer().then(openCart);
      }
    })
  );
  qsa('[data-cart-close]').forEach((el) => el.addEventListener('click', closeCart));

  const updateCartCount = (n) => {
    const count = Number(n) || 0;
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };

  const getDemoCart = () => {
    try {
      return JSON.parse(sessionStorage.getItem(DEMO_CART_KEY) || '[]');
    } catch (_) {
      return [];
    }
  };
  const setDemoCart = (items) => sessionStorage.setItem(DEMO_CART_KEY, JSON.stringify(items));
  const demoCartCount = () => getDemoCart().reduce((sum, i) => sum + (Number(i.quantity) || 1), 0);

  const fetchCart = async () => {
    const res = await fetch(`${root()}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  };

  const emptyCartHtml = () => `<div class="empty-state" style="padding:2rem 0">
    <p class="script" style="font-size:1.8rem">Your space awaits</p>
    <p style="margin:0.75rem 0 1.25rem">No pieces in the cart yet.</p>
    <a class="btn" href="${shopHref()}" data-cart-close>Browse decoratives</a>
  </div>`;

  const bindEmptyClose = (body) => {
    body.querySelectorAll('[data-cart-close]').forEach((el) => {
      el.addEventListener('click', closeCart);
    });
  };

  const renderDemoDrawer = () => {
    const body = qs('[data-cart-drawer] .cart-drawer__body');
    const foot = qs('[data-cart-drawer] .cart-drawer__foot');
    if (!body) return;
    const items = getDemoCart();
    updateCartCount(demoCartCount());

    if (!items.length) {
      body.innerHTML = emptyCartHtml();
      bindEmptyClose(body);
      if (foot) foot.hidden = true;
      return;
    }

    body.innerHTML = items
      .map(
        (item) => `<div class="cart-line">
          ${item.image ? `<img src="${item.image}" alt="" width="72" height="90" loading="lazy">` : ''}
          <div>
            <a href="${item.url || shopHref()}"><strong>${item.title || 'Product'}</strong></a>
            <p style="font-size:0.85rem;opacity:0.7">Qty ${item.quantity || 1}</p>
            <p>${item.price || ''}</p>
          </div>
          <button type="button" aria-label="Remove" data-demo-remove="${item.id}">×</button>
        </div>`
      )
      .join('');

    body.querySelectorAll('[data-demo-remove]').forEach((btn) => {
      btn.addEventListener('click', () => {
        setDemoCart(getDemoCart().filter((i) => String(i.id) !== String(btn.getAttribute('data-demo-remove'))));
        renderDemoDrawer();
      });
    });

    if (foot) {
      foot.hidden = false;
      foot.innerHTML = `
        <p style="font-size:0.85rem;opacity:0.75;margin:0">Preview cart — publish products in Shopify to checkout.</p>
        <a class="btn" href="${shopHref()}" data-cart-close>Continue shopping</a>`;
      foot.querySelectorAll('[data-cart-close]').forEach((el) => el.addEventListener('click', closeCart));
    }
  };

  const addDemoItem = (payload) => {
    const items = getDemoCart();
    const id = String(payload.id || `demo-${Date.now()}`);
    const existing = items.find((i) => String(i.id) === id);
    if (existing) {
      existing.quantity = (Number(existing.quantity) || 1) + (Number(payload.quantity) || 1);
    } else {
      items.push({
        id,
        title: payload.title || 'Decorative piece',
        price: payload.price || '',
        url: payload.url || shopHref(),
        image: payload.image || '',
        quantity: Number(payload.quantity) || 1
      });
    }
    setDemoCart(items);
    renderDemoDrawer();
    openCart();
  };

  const refreshCartDrawer = async () => {
    const body = qs('[data-cart-drawer] .cart-drawer__body');
    const foot = qs('[data-cart-drawer] .cart-drawer__foot');
    if (!body) return null;

    try {
      const cart = await fetchCart();

      if (!cart.item_count) {
        if (getDemoCart().length) {
          renderDemoDrawer();
          return cart;
        }
        updateCartCount(0);
        body.innerHTML = emptyCartHtml();
        bindEmptyClose(body);
        if (foot) foot.hidden = true;
        return cart;
      }

      /* Real Shopify items win — clear preview cart */
      setDemoCart([]);
      updateCartCount(cart.item_count);

      body.innerHTML = cart.items
        .map(
          (item) => `<div class="cart-line">
            ${item.image ? `<img src="${item.image}" alt="" width="72" height="90" loading="lazy">` : ''}
            <div>
              <a href="${item.url}"><strong>${item.product_title || item.title}</strong></a>
              <p style="font-size:0.85rem;opacity:0.7">Qty ${item.quantity}</p>
              <p>${money(item.final_line_price)}</p>
            </div>
            <button type="button" aria-label="Remove" data-cart-remove="${item.key}">×</button>
          </div>`
        )
        .join('');

      body.querySelectorAll('[data-cart-remove]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          await fetch(`${root()}cart/change.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: btn.getAttribute('data-cart-remove'), quantity: 0 })
          });
          await refreshCartDrawer();
        });
      });

      if (foot) {
        foot.hidden = false;
        foot.innerHTML = `
          <div style="display:flex;justify-content:space-between;font-weight:700">
            <span>Subtotal</span>
            <span>${money(cart.total_price)}</span>
          </div>
          <a class="btn" href="${root()}cart">View cart</a>
          <a class="btn btn--sky" href="/checkout">Checkout</a>`;
      }
      return cart;
    } catch (_) {
      renderDemoDrawer();
      return null;
    }
  };

  const addToCart = async (variantId, qty = 1) => {
    const id = String(variantId || '').trim();
    if (!id || id === '0') throw new Error('Missing variant');

    const payload = { id, quantity: Number(qty) || 1 };
    let res = await fetch(`${root()}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });

    /* Fallback: items[] format */
    if (!res.ok) {
      res = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: Number(qty) || 1 }] })
      });
    }

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Add failed');

    setDemoCart([]);
    await refreshCartDrawer();
    openCart();
    return true;
  };

  const cardPayload = (btn) => {
    const card = btn.closest('[data-product-card]');
    const wish = card?.querySelector('[data-wishlist-toggle]');
    return {
      id: btn.dataset.demoId || card?.getAttribute('data-product-id') || `demo-${Date.now()}`,
      title:
        btn.dataset.title ||
        wish?.dataset.title ||
        card?.querySelector('.product-card__title')?.textContent?.trim() ||
        'Decorative piece',
      price:
        btn.dataset.price ||
        wish?.dataset.price ||
        card?.querySelector('.product-card__price')?.textContent?.trim() ||
        '',
      url: btn.dataset.url || wish?.dataset.url || card?.querySelector('a')?.href || shopHref(),
      image: btn.dataset.image || wish?.dataset.image || card?.querySelector('img')?.src || '',
      quantity: 1
    };
  };

  /* Wishlist */
  const getWish = () => {
    try {
      return JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
    } catch (_) {
      return [];
    }
  };
  const setWish = (items) => localStorage.setItem(WISH_KEY, JSON.stringify(items));

  const wishDrawer = qs('[data-wishlist-drawer]');
  const openWish = () => {
    renderWish();
    wishDrawer?.classList.add('is-open');
  };
  const closeWish = () => wishDrawer?.classList.remove('is-open');
  qsa('[data-wishlist-open]').forEach((el) => el.addEventListener('click', openWish));
  qsa('[data-wishlist-close]').forEach((el) => el.addEventListener('click', closeWish));

  const syncWishButtons = () => {
    const ids = new Set(getWish().map((i) => String(i.id)));
    qsa('[data-wishlist-toggle]').forEach((btn) => {
      const on = ids.has(String(btn.dataset.id));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
    const count = qs('[data-wishlist-count]');
    if (count) {
      count.textContent = ids.size;
      count.hidden = ids.size === 0;
    }
    qsa('[data-wishlist-open]').forEach((btn) => {
      btn.classList.toggle('is-active', ids.size > 0);
    });
  };

  const renderWish = () => {
    const list = qs('[data-wishlist-list]');
    if (!list) return;
    const items = getWish();
    if (!items.length) {
      list.innerHTML = `<div class="empty-state" style="padding:2rem 0">
        <p class="script" style="font-size:1.8rem">Save your favourites</p>
        <p style="margin:0.75rem 0 1.25rem">Tap the heart on any piece to add it here.</p>
      </div>`;
      return;
    }
    list.innerHTML = items
      .map(
        (item) => `<div class="wish-line" data-wish-id="${item.id}">
        <a href="${item.url || '#'}"><img src="${item.image || ''}" alt="" width="72" height="90" loading="lazy"></a>
        <div>
          <a href="${item.url || '#'}"><strong>${item.title || 'Product'}</strong></a>
          <p style="font-size:0.85rem;opacity:0.75;margin:0.25rem 0">${item.price || ''}</p>
          <div class="wish-line__actions">
            <a class="btn btn--ink" style="min-height:2.2rem;padding:0.4rem 0.85rem;font-size:0.68rem" href="${item.url || '#'}">View</a>
            <button type="button" class="btn" style="min-height:2.2rem;padding:0.4rem 0.85rem;font-size:0.68rem" data-wish-remove="${item.id}">Remove</button>
          </div>
        </div>
      </div>`
      )
      .join('');
    list.querySelectorAll('[data-wish-remove]').forEach((btn) => {
      btn.addEventListener('click', () => {
        setWish(getWish().filter((i) => String(i.id) !== String(btn.dataset.wishRemove)));
        syncWishButtons();
        renderWish();
      });
    });
  };

  qsa('[data-wishlist-toggle]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const id = String(btn.dataset.id);
      let items = getWish();
      if (items.some((i) => String(i.id) === id)) {
        items = items.filter((i) => String(i.id) !== id);
      } else {
        items.push({
          id,
          handle: btn.dataset.handle,
          title: btn.dataset.title,
          price: btn.dataset.price,
          url: btn.dataset.url,
          image: btn.dataset.image
        });
      }
      setWish(items);
      syncWishButtons();
    });
  });
  syncWishButtons();

  /* Card add to cart */
  qsa('[data-add-to-cart]').forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      const label = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      try {
        const card = btn.closest('[data-product-card]');
        const variantId = btn.dataset.variantId || card?.getAttribute('data-variant-id');
        const isDemo = btn.dataset.demo === 'true' || !variantId || variantId === '0';

        if (isDemo) {
          addDemoItem(cardPayload(btn));
        } else {
          try {
            await addToCart(variantId, 1);
          } catch (_) {
            addDemoItem(cardPayload(btn));
          }
        }
        btn.textContent = 'Added';
        setTimeout(() => {
          btn.textContent = label;
          btn.disabled = false;
        }, 1200);
      } catch (_) {
        btn.textContent = label;
        btn.disabled = false;
      }
    });
  });

  /* Reveal on scroll */
  const reveals = qsa('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const markInView = () => {
      reveals.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92 && r.bottom > 0) el.classList.add('is-in');
      });
    };
    markInView();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -4% 0px' }
    );
    reveals.forEach((el, i) => {
      if (el.classList.contains('is-in')) return;
      el.style.transitionDelay = `${Math.min(i % 6, 5) * 70}ms`;
      io.observe(el);
    });
    window.addEventListener('load', markInView, { once: true });
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  /* Product gallery + zoom */
  const mainImg = qs('[data-gallery-main]');
  const zoomRoot = qs('[data-product-zoom]');
  const zoomStage = qs('[data-zoom-stage]', zoomRoot || document);
  const zoomFrame = qs('[data-zoom-frame]', zoomRoot || document);
  const zoomInBtn = qs('[data-zoom-in]', zoomRoot || document);
  const zoomOutBtn = qs('[data-zoom-out]', zoomRoot || document);
  const zoomResetBtn = qs('[data-zoom-reset]', zoomRoot || document);
  let zoomScale = 1;
  let zoomX = 0;
  let zoomY = 0;
  const ZOOM_MIN = 1;
  const ZOOM_MAX = 3;
  const ZOOM_STEP = 0.4;

  const clampZoom = (value, min, max) => Math.min(max, Math.max(min, value));
  const applyZoom = () => {
    if (!zoomFrame || !zoomStage) return;
    zoomScale = clampZoom(zoomScale, ZOOM_MIN, ZOOM_MAX);
    if (zoomScale <= ZOOM_MIN) {
      zoomScale = ZOOM_MIN;
      zoomX = 0;
      zoomY = 0;
    }
    zoomFrame.style.transform = `translate(${zoomX}px, ${zoomY}px) scale(${zoomScale})`;
    zoomStage.classList.toggle('is-zoomed', zoomScale > 1.01);
    if (zoomInBtn) zoomInBtn.disabled = zoomScale >= ZOOM_MAX - 0.01;
    if (zoomOutBtn) zoomOutBtn.disabled = zoomScale <= ZOOM_MIN + 0.01;
    if (zoomResetBtn) zoomResetBtn.hidden = zoomScale <= ZOOM_MIN + 0.01;
  };
  const setZoom = (next, originX, originY) => {
    if (!zoomStage) return;
    const rect = zoomStage.getBoundingClientRect();
    const cx = originX == null ? rect.width / 2 : originX;
    const cy = originY == null ? rect.height / 2 : originY;
    const prev = zoomScale;
    const nextScale = clampZoom(next, ZOOM_MIN, ZOOM_MAX);
    if (prev === nextScale) return;
    const ratio = nextScale / prev;
    zoomX = cx - (cx - zoomX) * ratio;
    zoomY = cy - (cy - zoomY) * ratio;
    zoomScale = nextScale;
    applyZoom();
  };
  const resetZoom = () => {
    zoomScale = 1;
    zoomX = 0;
    zoomY = 0;
    applyZoom();
  };

  if (zoomStage && zoomFrame) {
    applyZoom();
    zoomInBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      setZoom(zoomScale + ZOOM_STEP);
    });
    zoomOutBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      setZoom(zoomScale - ZOOM_STEP);
    });
    zoomResetBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      resetZoom();
    });

    zoomStage.addEventListener(
      'wheel',
      (e) => {
        if (!e.ctrlKey && Math.abs(e.deltaY) < 2) return;
        e.preventDefault();
        const rect = zoomStage.getBoundingClientRect();
        const dir = e.deltaY < 0 ? ZOOM_STEP : -ZOOM_STEP;
        setZoom(zoomScale + dir, e.clientX - rect.left, e.clientY - rect.top);
      },
      { passive: false }
    );

    let dragging = false;
    let startX = 0;
    let startY = 0;
    let originX = 0;
    let originY = 0;
    const onPointerDown = (e) => {
      if (zoomScale <= 1.01) return;
      dragging = true;
      zoomStage.classList.add('is-dragging');
      startX = e.clientX;
      startY = e.clientY;
      originX = zoomX;
      originY = zoomY;
      zoomStage.setPointerCapture?.(e.pointerId);
    };
    const onPointerMove = (e) => {
      if (!dragging) return;
      zoomX = originX + (e.clientX - startX);
      zoomY = originY + (e.clientY - startY);
      applyZoom();
    };
    const onPointerUp = (e) => {
      if (!dragging) return;
      dragging = false;
      zoomStage.classList.remove('is-dragging');
      try {
        zoomStage.releasePointerCapture?.(e.pointerId);
      } catch (_) {}
    };
    zoomStage.addEventListener('pointerdown', onPointerDown);
    zoomStage.addEventListener('pointermove', onPointerMove);
    zoomStage.addEventListener('pointerup', onPointerUp);
    zoomStage.addEventListener('pointercancel', onPointerUp);

    let pinchStart = 0;
    let pinchScale = 1;
    zoomStage.addEventListener(
      'touchstart',
      (e) => {
        if (e.touches.length === 2) {
          const [a, b] = e.touches;
          pinchStart = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
          pinchScale = zoomScale;
        }
      },
      { passive: true }
    );
    zoomStage.addEventListener(
      'touchmove',
      (e) => {
        if (e.touches.length !== 2 || !pinchStart) return;
        e.preventDefault();
        const [a, b] = e.touches;
        const dist = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        const rect = zoomStage.getBoundingClientRect();
        const midX = (a.clientX + b.clientX) / 2 - rect.left;
        const midY = (a.clientY + b.clientY) / 2 - rect.top;
        setZoom(pinchScale * (dist / pinchStart), midX, midY);
      },
      { passive: false }
    );
    zoomStage.addEventListener('dblclick', (e) => {
      e.preventDefault();
      const rect = zoomStage.getBoundingClientRect();
      if (zoomScale > 1.01) resetZoom();
      else setZoom(2, e.clientX - rect.left, e.clientY - rect.top);
    });
  }

  qsa('[data-gallery-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const src = btn.getAttribute('data-src');
      if (mainImg && src) {
        mainImg.src = src;
        qsa('[data-gallery-thumb]').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        resetZoom();
      }
    });
  });

  /* Quantity steppers */
  qsa('[data-qty]').forEach((wrap) => {
    const input = qs('input', wrap);
    qs('[data-qty-minus]', wrap)?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) - 1);
    });
    qs('[data-qty-plus]', wrap)?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
    });
  });

  /* Product details form — Add to cart + Buy now */
  qsa('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitter = e.submitter;
      const buyNow = submitter?.hasAttribute('data-buy-now');
      const idInput = form.querySelector('[name="id"]');
      const qtyInput = form.querySelector('[name="quantity"]');
      const variantId = idInput?.value;
      const qty = qtyInput?.value || 1;
      const btn = submitter;
      const label = btn?.textContent;
      const wish = form.closest('[data-product-page]')?.querySelector('[data-wishlist-toggle]');

      if (btn) {
        btn.textContent = buyNow ? 'Redirecting…' : 'Adding…';
        btn.disabled = true;
      }

      const fallbackDemo = () => {
        addDemoItem({
          id: wish?.dataset.id || `pdp-${Date.now()}`,
          title: wish?.dataset.title || document.querySelector('h1')?.textContent?.trim() || 'Product',
          price: wish?.dataset.price || '',
          url: wish?.dataset.url || window.location.pathname,
          image: wish?.dataset.image || qs('[data-gallery-main]')?.src || '',
          quantity: Number(qty) || 1
        });
      };

      try {
        if (!variantId || variantId === '0') {
          fallbackDemo();
        } else {
          await addToCart(variantId, qty);
          if (buyNow) {
            window.location.href = '/checkout';
            return;
          }
        }
        if (btn) {
          btn.textContent = 'Added';
          setTimeout(() => {
            btn.textContent = label;
            btn.disabled = false;
          }, 1200);
        }
      } catch (_) {
        fallbackDemo();
        if (btn) {
          btn.textContent = 'Added';
          setTimeout(() => {
            btn.textContent = label;
            btn.disabled = false;
          }, 1200);
        }
      }
    });
  });

  /* Keep cart count fresh on load */
  refreshCartDrawer().catch(() => {
    updateCartCount(demoCartCount());
  });

  /* Google reviews — auto-scroll on phone */
  const initReviewsScroll = () => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    qsa('[data-reviews-scroll]').forEach((wrap) => {
      const track = wrap.querySelector('.reviews-marquee__track');
      if (!track || track.dataset.bound === 'true') return;
      track.dataset.bound = 'true';

      const isPhone = () => window.matchMedia('(max-width: 800px)').matches;
      const originals = [...track.children];
      originals.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.classList.add('is-clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        track.appendChild(clone);
      });

      let paused = false;
      let hovering = false;
      const pause = () => { paused = true; };
      const resume = () => { paused = false; };

      track.addEventListener('pointerdown', pause);
      track.addEventListener('touchstart', pause, { passive: true });
      track.addEventListener('mouseenter', () => { hovering = true; pause(); });
      track.addEventListener('mouseleave', () => { hovering = false; resume(); });
      track.addEventListener('pointerup', () => { if (!hovering) resume(); });
      track.addEventListener('pointercancel', resume);
      track.addEventListener('touchend', () => setTimeout(resume, 1800));

      const tick = () => {
        if (isPhone() && !paused && !reduced) {
          const half = track.scrollWidth / 2;
          track.scrollLeft += 0.55;
          if (track.scrollLeft >= half) track.scrollLeft -= half;
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  };
  initReviewsScroll();

  /* Notify me — sold out products */
  qsa('[data-notify-me]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const title = btn.getAttribute('data-product-title') || 'this piece';
      const wa = 'https://wa.me/919643377269?text=' + encodeURIComponent(`Hi Viora, please notify me when "${title}" is back in stock.`);
      window.open(wa, '_blank', 'noopener');
    });
  });
})();
